// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ALBUM_DESCRIPTION_SHOW_MORE = "Zobraz viac";
